import PropTypes from 'prop-types';

// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import MKInput from 'components/MKInput';
import MKButton from 'components/MKButton';

// Images
import newsletter_img from 'assets/csdd_images/newsletter-img.jpg';
function Newsletter() {
  return (
    <MKBox component='section' pt={6} my={6}>
      <Container>
        <Grid container alignItems='center'>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ ml: { xs: 0, lg: 3 }, mb: { xs: 12, md: 0 } }}
          >
            <MKTypography color='error' variant='h3' textGradient>
              Want to be the first to get our latest industry updates?
            </MKTypography>
            <MKTypography variant='body2' color='black' mb={3} textGradient>
              Subscribe to our email newsletter and be the first to get the
              latest industry updates via your email.
            </MKTypography>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <MKInput type='email' label='Email Here...' fullWidth />
              </Grid>
              <Grid item xs={4}>
                <MKButton
                  variant='contained'
                  color='warning'
                  sx={{ height: '100%' }}
                >
                  Subscribe
                </MKButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={5} sx={{ ml: 'auto' }}>
            <MKBox position='relative'>
              <MKBox
                component='img'
                src={newsletter_img}
                alt='Image of a newspaper'
                width='100%'
                borderRadius='4px'
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

Newsletter.propTypes = {
  marginTop: PropTypes.number,
};

export default Newsletter;
